import { ChakraProvider, useBreakpointValue } from "@chakra-ui/react";
import React, { useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import Routes from "./routes";
import theme from "./theme/theme.config";
import { HashRouter as Router, useLocation } from "react-router-dom";
import ApplicationContextProvider, {
  AppContext,
  ApplicationActionType,
} from "./context/ApplicationContext";
import CleverTapContextProvider from "./clevertap/CleverTapProvider";
import * as Sentry from "@sentry/react";
import { MatomoProvider, createInstance } from "@datapunt/matomo-tracker-react";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { isProgramPresent } from "./components/common/utils/isProgramPresent";

// import Maintenance from "./assets/maintenance.svg";
// import MaintenanceMobile from "./assets/maintenance_mobile.svg";
// import TagManager from "react-gtm-module";

// const tagManagerArgs = {
//   gtmId: "GTM-TC5WPBG",
// };
// TagManager.initialize(tagManagerArgs);
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_SENTRY_ENV,
});
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dataLayer: any; //
  }
}
declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Razorpay: any; //
  }
}
const MATOMO_URL = "https://analytics.masaischool.com/";
const MATOMO_SITE_ID = 3;
const instance = createInstance({
  urlBase: MATOMO_URL,
  siteId: MATOMO_SITE_ID,
});
const App = () => {
  const state = useContext(AppContext)[0];
  const dispatch = React.useContext(AppContext)[1];
  const location = useLocation();
  const { pushInstruction } = useMatomo();
  useEffect(() => {
    if (typeof window.location.host !== "string") {
      return;
    }
    const isScholar = window.location.host.includes("prepleaf.com") ? true : false;
    dispatch({
      type: ApplicationActionType.SET_SCHOLAR_STATUS,
      payload: { isScholar },
    });
  }, []);

  useEffect(() => {
    if (window && window.dataLayer) {
      window.dataLayer.push({ user_id: state.profileData?.slug });
    }
    if (state.profileData?.slug) {
      pushInstruction("setUserId", state.profileData?.slug);
    }
  }, [state.profileData?.slug]);

  useEffect(() => {
    if (state.profileData?.redirect_to_learnworld && state.profileData?.learnworld_url) {
      window.location.href = state.profileData?.learnworld_url;
    }
  }, [state.profileData?.redirect_to_learnworld]);

  useEffect(() => {
    if (typeof window.location.host !== "string") {
      return;
    }
    console.log("window.location.host-->", window.location.host);
    console.log("window.location.pathname-->", window.location.pathname);
    console.log("window.location.url-->", window.location.href);
    const isPrepleafHost = window.location.host.includes("prepleaf.com") ? true : false;
    const programs = state.profileData?.programs;
    // when profile is loaded
    if (state && state.profileData) {
      // TODO: need to revert this if condition after on 21st dec 2022
      // if (isPrepleafHost) {
      //   window.location.href = window.location.href.replace("prepleaf.com", "masaischool.com");
      //   return;
      // }
      // check if program is assigned or not
      if (programs) {
        // redirect user based on program and hostname
        // dashboard.masaischool.com
        // -> not eligible for masai_one and masaiX -> redirect him
        if (
          !(
            isProgramPresent("Masai_One", state.profileData?.programs) ||
            isProgramPresent("MasaiX", state.profileData?.programs)
          ) &&
          !isPrepleafHost
        ) {
          window.location.href = window.location.href.replace("masaischool.com", "prepleaf.com");
        }
        // program name is not scholar and user arrive on scholar domain then redirect to masai domain
        // dashboard.prepleaf.com
        // -> not eligible for CAP and Scholar -> redirect him
        else if (
          !(
            isProgramPresent("scholar", state.profileData?.programs) ||
            isProgramPresent("cap", state.profileData?.programs)
          ) &&
          isPrepleafHost
        ) {
          window.location.href = window.location.href.replace("prepleaf.com", "masaischool.com");
        }
      } else {
        // do nothing as we can't decide whether to redirect user on masai or prepleaf dashboard
      }
    }
  }, [state.profileData?.programs]);

  // Changing og image for prepleaf and masai dashboard
  useEffect(() => {
    const tag = document.querySelector("[property='og:image']");

    if (window.location.toString().includes("prepleaf.com")) {
      tag?.setAttribute(
        "content",
        "https://masai-website-images.s3.ap-south-1.amazonaws.com/Prepleaf_Dashboard_ee0c5dce0c.png"
      );
    } else {
      tag?.setAttribute("content", "https://d27028dliefpk3.cloudfront.net/brand/masai-school.png");
    }
  }, []);

  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <>
      <Routes />
      {/* <Image w={"100%"} h={"100%"} src={isMobile ? MaintenanceMobile : Maintenance} /> */}
    </>
  );
};

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <CleverTapContextProvider>
        <ChakraProvider theme={theme}>
          <ApplicationContextProvider>
            <MatomoProvider value={instance}>
              <App />
            </MatomoProvider>
          </ApplicationContextProvider>
        </ChakraProvider>
      </CleverTapContextProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root")
);
